// extracted by mini-css-extract-plugin
module.exports = {"helper-text":"form-helper-text_helper-text__iDOY3 token-typography-body-100 mds-typography-font-weight-regular"};